import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface StepBlockProps {
  number: number;
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

export default function StepBlock({ number, title, icon, children }: StepBlockProps) {
  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
        <Box sx={{
          width: 24, height: 24, borderRadius: '6px', bgcolor: 'action.hover',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '0.7rem', fontWeight: 800, color: 'text.secondary',
        }}>
          {number}
        </Box>
        <Box sx={{ color: 'text.secondary', display: 'flex', fontSize: 18 }}>{icon}</Box>
        <Typography sx={{ fontWeight: 600, fontSize: '0.95rem' }}>{title}</Typography>
      </Box>
      {children}
    </Box>
  );
}
